import { FC } from 'external/react'
import { styled, MobileTimePicker as MuiMobileTimePicker} from 'external/material'
import {dayjs} from 'external/dayjs'

export type MobileTimePickerProps = {
  value: Date
  minTime?: Date | null
  maxTime?: Date | null
  onChange?: (value: dayjs.Dayjs | null) => void;
  onAccept?: (value: dayjs.Dayjs | null) => void;
}

const StyledMobileTimePicker = styled(MuiMobileTimePicker)(mobileTimePickerStyles as any)

const  MobileTimePicker: FC<MobileTimePickerProps> = props => {
  const {value, minTime, maxTime, onChange, onAccept} = props
  return (
    <StyledMobileTimePicker
      value={dayjs(value)}
      minTime={minTime ? dayjs(minTime) : undefined}
      maxTime={maxTime ? dayjs(maxTime) : undefined}
      onChange={onChange}
      onAccept={onAccept}
    />
  )
}

export {MobileTimePicker as default}

function mobileTimePickerStyles(){
  return {
    width: '131px',
    height: '32px',
    border: 'none',
    backgroundColor: 'transparent',
    '& .MuiPickersInputBase-sectionsContainer': {padding: 8},
    '& .MuiOutlinedInput-root': { border: 'none', outline: 'none', padding: 0 },
    '& .MuiOutlinedInput-notchedOutline': { border: 'none', outline: 'none' },
    '& .MuiIconButton-root': { padding: '0 8px 0 0'},
    padding: 0,
    '& .MuiInputBase-input': {
      height: '32px',
      padding: 0,
      textAlign: 'center',
      fontSize: '16px',
      color: '#000',
    },
  } 
}